(() => {
  const dialog = document.getElementById('CozikatProductQuiz');
  if (!dialog || dialog.dataset.ready === 'true') return;
  dialog.dataset.ready = 'true';

  const STORAGE_DISMISSED = 'cozikatQuizDismissedAt';
  const STORAGE_COMPLETED = 'cozikatQuizCompleted';
  const DISMISS_FOR_MS = 24 * 60 * 60 * 1000;
  const AUTO_OPEN_DELAY = 8000;

  const form = dialog.querySelector('[data-quiz-form]');
  const steps = Array.from(dialog.querySelectorAll('[data-quiz-step]'));
  const results = dialog.querySelector('[data-quiz-results]');
  const progressWrap = dialog.querySelector('[data-quiz-progress-wrap]');
  const progress = dialog.querySelector('[data-quiz-progress]');
  const progressBar = dialog.querySelector('[data-quiz-progress-bar]');
  const stepText = dialog.querySelector('[data-quiz-step-text]');
  const percentText = dialog.querySelector('[data-quiz-percent]');
  const backButton = dialog.querySelector('[data-quiz-back]');
  const nextButton = dialog.querySelector('[data-quiz-next]');
  const resultTitle = dialog.querySelector('[data-quiz-result-title]');
  const resultIntro = dialog.querySelector('[data-quiz-result-intro]');
  const recommendations = dialog.querySelector('[data-quiz-recommendations]');
  let currentStep = 0;
  let completed = false;
  let lastTrigger = null;

  const storage = {
    get(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        // The quiz still works if storage is disabled.
      }
    },
    remove(key) {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        // The quiz still works if storage is disabled.
      }
    },
  };

  function wasRecentlyDismissed() {
    const dismissedAt = Number(storage.get(STORAGE_DISMISSED));
    return dismissedAt > 0 && Date.now() - dismissedAt < DISMISS_FOR_MS;
  }

  function updateStep(focusQuestion = false) {
    steps.forEach((step, index) => {
      step.hidden = index !== currentStep;
      const error = step.querySelector('[role="alert"]');
      if (error) error.hidden = true;
    });

    const percent = Math.round(((currentStep + 1) / steps.length) * 100);
    stepText.textContent = `Question ${currentStep + 1} of ${steps.length}`;
    percentText.textContent = `${percent}%`;
    progress.setAttribute('aria-valuenow', String(percent));
    progressBar.style.width = `${percent}%`;
    backButton.hidden = currentStep === 0;
    nextButton.textContent = currentStep === steps.length - 1 ? 'Show my match' : 'Next question';

    if (focusQuestion) {
      const selected = steps[currentStep].querySelector('input:checked');
      const firstInput = steps[currentStep].querySelector('input');
      (selected || firstInput)?.focus({ preventScroll: true });
    }
  }

  function openQuiz(trigger = null) {
    if (dialog.open) return;
    lastTrigger = trigger;
    document.querySelector('#Details-menu-drawer-container')?.removeAttribute('open');
    dialog.showModal();
    window.requestAnimationFrame(() => {
      const focusTarget = results.hidden
        ? steps[currentStep].querySelector('input:checked') || steps[currentStep].querySelector('input')
        : dialog.querySelector('[data-quiz-result-title]');
      focusTarget?.focus({ preventScroll: true });
    });
  }

  function closeQuiz() {
    if (!completed) storage.set(STORAGE_DISMISSED, String(Date.now()));
    dialog.close();
    lastTrigger?.focus({ preventScroll: true });
  }

  function currentAnswer() {
    return steps[currentStep].querySelector('input:checked');
  }

  function answers() {
    return Object.fromEntries(new FormData(form).entries());
  }

  function rankedMatches(answerSet) {
    const score = { bella: 0, luna: 0, honey: 0, bundle: 0 };

    if (answerSet.q1 === 'curl') score.bella += 5;
    if (answerSet.q1 === 'stretch') score.luna += 5;
    if (answerSet.q1 === 'scratch') score.honey += 5;
    if (answerSet.q1 === 'mix') score.bundle += 4;

    if (answerSet.q2 === 'flat') score.honey += 5;
    if (answerSet.q2 === 'curved') {
      score.luna += 4;
      score.bella += 2;
    }
    if (answerSet.q2 === 'furniture') {
      score.bella += 3;
      score.luna += 3;
    }
    if (answerSet.q2 === 'both') score.bundle += 4;

    if (answerSet.q3 === 'small') {
      score.honey += 2;
      score.bella += 1;
    }
    if (answerSet.q3 === 'average') {
      score.bella += 2;
      score.luna += 2;
    }
    if (answerSet.q3 === 'large') score.luna += 5;
    if (answerSet.q3 === 'multi') score.bundle += 6;

    if (answerSet.q4 === 'cozy') score.bella += 7;
    if (answerSet.q4 === 'open') score.luna += 7;
    if (answerSet.q4 === 'compact') score.honey += 7;
    if (answerSet.q4 === 'variety') score.bundle += 7;

    return Object.entries(score)
      .sort((a, b) => b[1] - a[1])
      .map(([key]) => key);
  }

  function showResult() {
    const ranked = rankedMatches(answers());
    const match = ranked[0];
    const copy = {
      bella: {
        title: 'Start with the Bella Scratch Bed',
        intro: 'The closest fit for curlers who want a sheltered nap spot with a scratchable surface.',
      },
      luna: {
        title: 'Start with the Luna Lounger',
        intro: 'The closest fit for stretchers and larger cats who prefer an open, generous lounging surface.',
      },
      honey: {
        title: 'Start with the Honey Pad',
        intro: 'The closest fit for horizontal scratchers and homes that need a compact, easy-to-place option.',
      },
      bundle: {
        title: 'Start with the CoziKat Bundle',
        intro: 'The closest fit for multi-cat homes and cats who switch between different lounging and scratching styles.',
      },
    };

    resultTitle.textContent = copy[match].title;
    resultIntro.textContent = copy[match].intro;
    recommendations.replaceChildren();
    ranked.slice(0, 3).forEach((productKey) => {
      const productTemplate = dialog.querySelector(`template[data-quiz-product="${productKey}"]`);
      if (productTemplate) recommendations.append(productTemplate.content.cloneNode(true));
    });

    form.hidden = true;
    progressWrap.hidden = true;
    results.hidden = false;
    dialog.classList.add('is-results');
    completed = true;
    storage.set(STORAGE_COMPLETED, 'true');
    storage.remove(STORAGE_DISMISSED);
    dialog.querySelector('[data-quiz-result-title]')?.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.cozikat-quiz-trigger');
    if (!trigger) return;
    event.preventDefault();
    openQuiz(trigger);
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
  });

  dialog.querySelector('[data-quiz-close]').addEventListener('click', closeQuiz);

  form.addEventListener('submit', (event) => event.preventDefault());

  nextButton.addEventListener('click', () => {
    const selected = currentAnswer();
    const error = steps[currentStep].querySelector('[role="alert"]');
    if (!selected) {
      error.hidden = false;
      steps[currentStep].querySelector('input')?.focus({ preventScroll: true });
      return;
    }

    if (currentStep < steps.length - 1) {
      currentStep += 1;
      updateStep(true);
    } else {
      showResult();
    }
  });

  backButton.addEventListener('click', () => {
    if (currentStep === 0) return;
    currentStep -= 1;
    updateStep(true);
  });

  dialog.querySelector('[data-quiz-retake]').addEventListener('click', () => {
    form.reset();
    currentStep = 0;
    completed = false;
    storage.remove(STORAGE_COMPLETED);
    results.hidden = true;
    form.hidden = false;
    progressWrap.hidden = false;
    dialog.classList.remove('is-results');
    updateStep(true);
  });

  updateStep();

  window.setTimeout(() => {
    if (dialog.open || storage.get(STORAGE_COMPLETED) === 'true' || wasRecentlyDismissed()) return;
    openQuiz();
  }, AUTO_OPEN_DELAY);
})();
